export default "__VITE_ASSET__BFWOSlFm__"